﻿import React, { useState } from 'react';
import { GetPromoItemList } from 'api/contentmanagement.js';
import { StrikeThroughHeader } from 'components/Headers/strikethrough-header/strikethrough-header';
import LoadingIndicator from 'components/Global/loading-indicator/loading-indicator';
import useReverseSort from '../../../hooks/util/useReverseSort/useReverseSort';
import { Grid, Button, Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import PromoItemCard from './PromoItemCard';
import Cart from '../../Marketing/Components/cart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import NotificationSnackbar from '../../../components/Global/NotificationSnackbar/NotificationSnackbar';

export default function PromoItemList(props) {
  const [duration, setDuration] = useState(10);
  const [status, setStatus] = useState('');
  const [showNotif, setShowNotif] = useState(false);
  const PromoItemListQuery = useQuery({
    queryKey: ['getPromoItemList'],
    queryFn: GetPromoItemList(),
  });
  const { reversed, setReversed, sortWithReverse, ReverseIcon } = useReverseSort('Title');

  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  const addToCart = (newItem) => {
    // 'cart' is an array holding items in the cart
    const existingItem = cart.find(
      (item) => item.id === newItem.id && item.color === newItem.color && item.size === newItem.size
    );

    if (existingItem) {
      // Update the quantity of the existing item in the cart
      setCart(
        cart.map((item) =>
          item === existingItem
            ? { ...item, quantity: parseInt(item.quantity) + parseInt(newItem.quantity) }
            : item
        )
      );
    } else {
      // Add the new item to the cart
      setCart([...cart, newItem]);
    }
  };

  function emailCallback(response) {
    setStatus(response == true ? 'success' : 'error');
    setShowNotif(true);
    handleCartClose();
  }

  const handleCartOpen = () => {
    setCartOpen(true);
  };

  const handleCartClose = () => {
    setCartOpen(false);
  };

  const getCardInterface = () => {
    if (PromoItemListQuery.isPending) {
      return <LoadingIndicator key="loading" />;
    }

    if (PromoItemListQuery.isError) {
      return <div>Error. Please try again later.</div>;
    }

    if (PromoItemListQuery.isSuccess && PromoItemListQuery.data) {
      return (
        <>
          <Grid container spacing={2}>
            {sortWithReverse(JSON.parse(PromoItemListQuery.data)).map((item) => (
              <Grid
                key={item.ID}
                size={{
                  xs: 12,
                  sm: 6,
                  md: 4,
                }}
              >
                <PromoItemCard item={item} addToCart={addToCart} />
              </Grid>
            ))}
          </Grid>
        </>
      );
    }
    return <></>;
  };

  return (
    <>
      <NotificationSnackbar
        duration={duration}
        status={status}
        openTrigger={showNotif}
        successMsg="Email successfully sent"
        errorMsg={'There was an error sending the email'}
      />

      <StrikeThroughHeader>Promo Items</StrikeThroughHeader>
      <Box
        sx={{
          position: 'sticky',
          top: '110px',
          paddingBottom: '1rem',
        }}
      >
        <Button
          onClick={handleCartOpen}
          variant="contained"
          color="primary"
          startIcon={<ShoppingCartIcon />}
        >
          View Cart
        </Button>
      </Box>
      {getCardInterface()}
      <Cart
        open={cartOpen}
        handleClose={handleCartClose}
        cart={cart}
        setCart={setCart}
        callback={emailCallback}
      />
    </>
  );
}
